package pl.decks.personal.pages.ievp.sections.insights

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Span

enum class Insight(val content: @Composable () -> Unit) {
    LATEST_YEARS({
        Span(attrs = InsightsSectionStylesheet.Entry.InsightText.toModifier().toAttrs()) {
            SpanText("I invested my lifetime savings and the past 3.5 years to give myself a shot as an ")
            SpanText("Entrepreneur", modifier = InsightsSectionStylesheet.Entry.InsightTextEmphasis.toModifier())
            SpanText(", working on my own projects. ")

            SpanText("Two ideas got killed quite fast. The last one was developed for 2.5 years and still operates without me on the board. ")
            SpanText("Monetary-wise, I failed. ")
            SpanText("I've learned a lot, though, especially when it comes to the bigger business picture and the struggles that my previous stakeholders must have faced on a daily basis.")
        }
    }),
    GROWTH({
        Span(attrs = InsightsSectionStylesheet.Entry.InsightText.toModifier().toAttrs()) {
            SpanText("During that time, I've grown in areas that supplement my previous expertise. ")

            SpanText("Designing, conducting or supervising a process of ")
            SpanText("idea validation", modifier = InsightsSectionStylesheet.Entry.InsightTextEmphasis.toModifier())
            SpanText(" is a matter of understanding now, not just knowledge. ")

            SpanText("I'm quite capable across all steps, be it ")
            SpanText("research, prototyping, scaling, product building...", modifier = InsightsSectionStylesheet.Entry.InsightTextEmphasis.toModifier())
            SpanText(" just name it. ")

            SpanText("I'll think about how to solve a problem and also what it takes to sell the solution. ")
            SpanText("If the missing information calls for customer support, I'll happily do that too. ")

        }
    }),
    SPECIALISATION({
        Span(attrs = InsightsSectionStylesheet.Entry.InsightText.toModifier().toAttrs()) {
            SpanText("I'm a specialist in everything that is data-related, with ")
            SpanText("formal education and 7 years of professional experience. ", modifier = InsightsSectionStylesheet.Entry.InsightTextEmphasis.toModifier())

            SpanText("Might even be a tad too obsessed with privacy and info-sec topics. ")
            SpanText("I've had the opportunity to get my hands on a variety of data systems: ")
            SpanText("Lakes, Warehouses, Lakehouses, Platforms... ", modifier = InsightsSectionStylesheet.Entry.InsightTextEmphasis.toModifier())

            SpanText("The solutions were both internal and client-facing, operating in unregulated and ")
            SpanText("highly regulated markets", modifier = InsightsSectionStylesheet.Entry.InsightTextEmphasis.toModifier())
            SpanText(" alike - healthcare, gambling. ")
        }
    }),
    DRIVE({
        Span(attrs = InsightsSectionStylesheet.Entry.InsightText.toModifier().toAttrs()) {
            SpanText("Finally, let me share my little vulnerability. ")
            SpanText("Yes, compensation is quite important. ")
            SpanText("Yes, it lets me progress my life and aspirations further. ")
            SpanText("Yet, what really drive me are a ")
            SpanText("noble mission ", modifier = InsightsSectionStylesheet.Entry.InsightTextEmphasis.toModifier())

            SpanText("and a ")
            SpanText("common, higher goal. ", modifier = InsightsSectionStylesheet.Entry.InsightTextEmphasis.toModifier())
            SpanText("An environment I can ")
            SpanText("contribute to", modifier = InsightsSectionStylesheet.Entry.InsightTextEmphasis.toModifier())
            SpanText(" and people I could ")
            SpanText("genuinely grow", modifier = InsightsSectionStylesheet.Entry.InsightTextEmphasis.toModifier())
            SpanText(" with. ")
            SpanText("Feel free to use it against me, when it comes to negotiations.")
        }
    }),
    ;
}
